// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__7OhdR","dragIcon":"SortableItem_dragIcon__19vOP","disabled":"SortableItem_disabled__mas7L"};